let _ = (t)=>t, t;
import { jsx as _jsx } from "react/jsx-runtime";
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { css } from '@emotion/react';
import { Element, tokens } from '@klarna/ui';
import RichTextMarkdown from 'features/richText/components/richTextMarkdown/RichTextMarkdown';
import { isDocument } from 'features/richText/utils/isDocument';
import { memo } from 'react';
const disclaimerStyles = css(t || (t = _`
  max-width: 100%;

  p,
  p > *,
  a {
    font-size: ${0}px;
    line-height: ${0}px;
    color: ${0};
  }

  a:hover {
    color: ${0};
  }
`), tokens.textSizes['text/desktop/xs'], tokens.lineHeights['body/desktop/xs'], tokens.colors.light['text/subtle'], tokens.colors.light['text/subtle']);
/**
 * Shared body renderer for the installments modals. Accepts either a
 * Contentful rich-text `Document` (BFF-sourced) or a markdown string
 * (legacy translations) and renders the subtle body text.
 *
 * Scoped to the modal path on purpose: the offer-list `SuperscriptedDisclosure`
 * renders the Document primitives inline instead of importing this
 * component, so `@contentful/rich-text-react-renderer` stays in the modal
 * chunk graph and doesn't get hoisted into `commons`.
 */ const Disclaimer = ({ children })=>{
    if (!children) return null;
    if (isDocument(children)) {
        return /*#__PURE__*/ _jsx(Element, {
            webOnlyProps: {
                css: disclaimerStyles
            },
            children: documentToReactComponents(children)
        });
    }
    return /*#__PURE__*/ _jsx(RichTextMarkdown, {
        sx: disclaimerStyles,
        children: children
    });
};
export default /*#__PURE__*/ memo(Disclaimer);
